const PROFILE_PREFERENCES = {
  showVideoInterview: "show_video_interview",
};

export default PROFILE_PREFERENCES;
